import client from './client';

export const syncOutlookCalendarApi = data => client().post('/outlook', data);

export const getOutlookAuthUrlApi = () => client().get('/outlook');
